const moveElement = (element, coordinates) => {
  const refElement = element;
  const posX = coordinates.currentCoordinateX - coordinates.startingCoordinateX;
  const posY = coordinates.currentCoordinateY - coordinates.startingCoordinateY;
  refElement.style.transform = `translate(${posX}px, ${posY}px)`;
};

export default moveElement;
